import { render, staticRenderFns } from "./PTabs.vue?vue&type=template&id=349903bf&scoped=true&"
import script from "./PTabs.vue?vue&type=script&lang=ts&"
export * from "./PTabs.vue?vue&type=script&lang=ts&"
import style0 from "./PTabs.vue?vue&type=style&index=0&id=349903bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349903bf",
  null
  
)

export default component.exports